/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS')
  .component('widgetActiveCampaigns', {
    templateUrl: '/templates/zenclerk_s/directives/dashboard/active_campaigns_widget.html',
    bindings: {
      project: '<',
    },
    controller(Campaign) {
      const vm = this;

      // variables

      // actions

      this.$onInit = () => {
        Campaign.all({projectId: vm.project.id}).then(campaigns => {
          vm.campaigns = _.filter(campaigns, d => d.current_status === 'active');
        });
      };
    }
  });



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/dashboard/active_campaigns_widget.js